module.exports = __webpack_public_path__ + "static/media/nhl-selector-color.8615ffc6.png";